// extracted by mini-css-extract-plugin
var _1 = "styles-module__container____bii7";
var _2 = "styles-module__label___Ew2RE";
var _3 = "styles-module__labelAndSelect___ybTYo";
var _4 = "styles-module__select___nHtDA";
export { _1 as "container", _2 as "label", _3 as "labelAndSelect", _4 as "select" }
